import React from 'react';
import PropTypes from 'prop-types';
import Portal from '../Portal';
import './Tooltip.scss';

class Tooltip extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };

    this.width = props.width || 200;
    this.space = props.space || 10;

    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
  }

  showTooltip() {
    // some maths to align the tooltip with whatever you just hovered over (the 'target')
    const style = { width: this.width };
    const dimensions = this.el.getBoundingClientRect();

    // center align the tooltip by taking both the target and tooltip widths into account
    style.left = dimensions.left + dimensions.width / 2 - this.width / 2;
    style.left = Math.max(this.space, style.left);
    style.left = Math.min(
      style.left,
      document.body.clientWidth - this.width - this.space,
    ); // or off the right

    if (dimensions.top < window.innerHeight / 4) {
      style.top = dimensions.top + dimensions.height + this.space;
    } else {
      style.bottom = window.innerHeight - dimensions.top + this.space;
    }

    this.setState({
      visible: true,
      style,
    });
  }

  hideTooltip() {
    this.setState({ visible: false });
  }

  render() {
    return (
      <span
        onFocus={this.showTooltip}
        onMouseOver={this.showTooltip}
        onBlur={this.hideTooltip}
        onMouseOut={this.hideTooltip}
        ref={(el) => {
          this.el = el;
        }}
      >
        {this.props.children}
        {this.state.visible && (
          <Portal>
            <div className="tooltipBody" style={this.state.style}>
              {this.props.text}
            </div>
          </Portal>
        )}
      </span>
    );
  }
}

Tooltip.propTypes = {
  children: PropTypes.any,
  text: PropTypes.any,
  width: PropTypes.number,
  space: PropTypes.number,
};

export default Tooltip;
